module.exports = __webpack_public_path__ + "assets/img/code-wb-b6c9f09f.png";